<template>
  <ErrorSuccessMessage />
  <NavigationComponent />
  <router-view />
</template>

<script>
  import NavigationComponent from "./components/NavigationComponent.vue";
  import ErrorSuccessMessage from "./components/smallComponents/ErrorSuccessMessage.vue";
  import {auth} from "./plugins/firebase";

  export default {
    name: "App",
    components: {
      ErrorSuccessMessage,
      NavigationComponent,
    },
    data() {
      return {
        mediaQuery: null,
      };
    },
    mounted() {
      // Sprache initialisieren
      let lang = localStorage.getItem("clgmbh-portal-lang");

      if (lang) {
        auth.languageCode = lang;
        this.$i18n.locale = lang;
      } else {
        lang = navigator.language.split("-")[0];
        auth.languageCode = lang;
        this.$i18n.locale = lang;
      }

      // Theme initialisieren basierend auf Browsereinstellung
      this.initializeTheme();
      this.setupThemeListener();
    },
    beforeUnmount() {
      // Event Listener entfernen
      if (this.mediaQuery) {
        this.mediaQuery.removeEventListener('change', this.handleThemeChange);
      }
    },
    methods: {
      initializeTheme() {
        // Browsereinstellung verwenden
        const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
        const theme = prefersDark ? "dark" : "light";
        document.documentElement.setAttribute("data-bs-theme", theme);
      },
      setupThemeListener() {
        // Media Query für prefers-color-scheme erstellen
        this.mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
        
        // Event Listener für Änderungen hinzufügen
        this.mediaQuery.addEventListener('change', this.handleThemeChange);
      },
      handleThemeChange(e) {
        // Theme automatisch anhand der Browsereinstellung ändern
        const theme = e.matches ? "dark" : "light";
        document.documentElement.setAttribute("data-bs-theme", theme);
      },
    },
  };
</script>
